
const CompletionMessage = () => {
  return (
    <div className="text-center mt-8 animate-fade-in">
      <div className="animate-float">
        <div className="inline-block bg-accent/10 text-accent p-3 rounded-full h-20 w-20 flex items-center justify-center mb-4">
          <svg className="h-10 w-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
      </div>
      <h3 className="text-xl font-bold text-primary mb-2">Assessment Complete!</h3>
      <p className="text-muted-foreground mb-4">
        Your career recommendations are being generated based on your responses.
      </p>
      <p className="text-sm bg-accent/10 text-accent p-3 rounded-lg">
        Tip: When viewing your results, you can click on any career to see more detailed information.
      </p>
    </div>
  );
};

export default CompletionMessage;
